import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref } from 'vue';
import IconButton from '../common/base/IconButton.vue';
import VirtualBackgroundIcon from '../common/icons/VirtualBackgroundIcon.vue';
import { useI18n } from '../../locales';
import { roomService } from '../../services';
import Dialog from '../common/base/Dialog';
import CloseVirtualBackground from '../../assets/imgs/close-virtual-background.png';
import BlurredBackground from '../../assets/imgs/blurred-background.png';
import TuiButton from '../common/base/Button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VirtualBackground',
  setup(__props) {

const { t } = useI18n();
const componentConfig =
  roomService.componentManager.getComponentConfig('VirtualBackground');
const isAllowed = computed(
  () => roomService.roomStore.localStream.hasVideoStream
);
const appliedBackground = ref<'close' | 'blur'>('close');
const selectedBackground = ref<'close' | 'blur'>('close');
const isDialogVisible = ref(false);
const isLoading = ref(false);
const openSettingPanel = async () => {
  roomService.virtualBackground.initVirtualBackground();
  isDialogVisible.value = true;
  isLoading.value = true;
  await nextTick();
  await roomService.roomEngine.instance?.startCameraDeviceTest({
    view: 'stream-preview',
  });
  isLoading.value = false;
};

const closeSettingPanel = async () => {
  isDialogVisible.value = false;
  await applyVirtualBackground(appliedBackground.value);
  roomService.roomEngine.instance?.stopCameraDeviceTest();
  selectedBackground.value = appliedBackground.value;
};

const confirmVirtualBackground = async () => {
  if (!isAllowed.value) return;
  appliedBackground.value = selectedBackground.value;
  closeSettingPanel();
  if (selectedBackground.value === 'blur') {
    await roomService.virtualBackground.toggleVirtualBackground(true);
  }
  if (selectedBackground.value === 'close') {
    await roomService.virtualBackground.toggleVirtualBackground(false);
  }
};

const applyVirtualBackground = async (type: 'close' | 'blur') => {
  isLoading.value = true;
  try {
    selectedBackground.value = type;
    await roomService.virtualBackground.toggleTestVirtualBackground(
      type === 'blur'
    );
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,t, componentConfig, isAllowed, appliedBackground, selectedBackground, isDialogVisible, isLoading, openSettingPanel, closeSettingPanel, confirmVirtualBackground, applyVirtualBackground, IconButton, VirtualBackgroundIcon, Dialog, CloseVirtualBackground, BlurredBackground, TuiButton }
}

})